import { cacheCode } from '@/utils/const/index'
// 固定缓存
export const currencylist = {
  // 货币的code
  expireM: 20,
  useCache: false,
  nochangeByParams: true,
  key: 'currencylist'
}

export const cloudbrokers = {
  // vps code
  expireM: 20,
  useCache: false,
  nochangeByParams: true,
  key: 'cloudbrokers'
}
// 固定缓存

// -------------------------------------------------------

// 国家缓存
export const headermenu = {
  // 顶部菜单
  expireM: 10,
  useCache: false,
  headers: [{ code: cacheCode.COUNTRY }],
  key: 'headermenu'
}

export const riskcontrol = {
  // 屏蔽点位
  expireM: 5,
  useCache: false,
  headers: [{ code: cacheCode.COUNTRY }],
  key: 'riskcontrol'
}

export const friendlink = {
  // 友情链接
  expireM: 20,
  useCache: false,
  headers: [{ code: cacheCode.COUNTRY }],
  key: 'friendlink'
}

export const partnetlist = {
  // 战略合作
  expireM: 20,
  useCache: false,
  headers: [{ code: cacheCode.COUNTRY }],
  key: 'partnetlist'
}
// 国家缓存

// ---------------------------------------------------------

// 语言缓存
export const country = {
  // 底部国家
  expireM: 20,
  useCache: false,
  headers: [{ code: cacheCode.LANGUAGE }],
  key: 'country'
}

// 语言缓存

// -----------------------------------------------------------

// 国家语言都要缓存
export const advertisement = {
  // 品牌广告
  expireM: 5,
  useCache: false,
  headers: [
    { code: cacheCode.LANGUAGE, dVal: ['zh-cn'] },
    { code: cacheCode.COUNTRY, dVal: ['cn'] }
  ],
  key: 'advertisement'
}

export const contactinfo = {
  // 底部联系方式
  expireM: 20,
  useCache: false,
  headers: [
    { code: cacheCode.LANGUAGE, dVal: ['zh-cn'] },
    { code: cacheCode.COUNTRY, dVal: ['cn'] }
  ],
  key: 'contactinfo'
}

export const noncooperativetrader = {
  // 推荐交易商
  expireM: 20,
  useCache: false,
  headers: [
    { code: cacheCode.LANGUAGE, dVal: ['zh-cn'] },
    { code: cacheCode.COUNTRY, dVal: ['cn'] }
  ],
  key: 'serviceproviderinfoall'
}
// 国家语言都要缓存
// -------------------------------------------------------------

// 固定写死的国家语言缓存
export const homedata = {
  // 推荐交易商
  expireM: 20,
  useCache: true,
  hasDefault: true,
  defaultCombination: [
    {
      lan: 'zh-cn',
      cou: 'cn'
    },
    {
      lan: 'en',
      cou: 'cn'
    },
    {
      lan: 'zh',
      cou: 'tw'
    },
    {
      lan: 'zh',
      cou: 'hk'
    },
    {
      lan: 'en',
      cou: 'hk'
    },
    {
      lan: 'vi',
      cou: 'vn'
    },
    {
      lan: 'en',
      cou: 'vn'
    },
    {
      lan: 'th',
      cou: 'th'
    },
    {
      lan: 'en',
      cou: 'th'
    },
    {
      lan: 'es',
      cou: 'es'
    },
    {
      lan: 'en',
      cou: 'es'
    },
    {
      lan: 'fil',
      cou: 'ph'
    },
    {
      lan: 'en',
      cou: 'ph'
    },
    {
      lan: 'en',
      cou: 'us'
    }
  ],
  key: 'homedata'
}
